function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsUpSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.068,1.079C19.49,1.363 20.414,2.746 20.13,4.168L20.004,4.792C19.714,6.252 19.178,7.641 18.429,8.904L26.304,8.904C27.753,8.904 28.929,10.08 28.929,11.529C28.929,12.913 27.862,14.045 26.506,14.149C26.927,14.614 27.179,15.232 27.179,15.904C27.179,17.184 26.26,18.25 25.052,18.48C25.292,18.874 25.429,19.344 25.429,19.842C25.429,21.007 24.669,21.996 23.619,22.336C23.657,22.516 23.679,22.707 23.679,22.904C23.679,24.354 22.503,25.529 21.054,25.529L17.034,25.529C15.995,25.529 14.984,25.223 14.119,24.649L12.014,23.243C10.554,22.27 9.679,20.629 9.679,18.874L9.679,12.793C9.679,11.196 10.406,9.692 11.648,8.691L12.052,8.368C13.502,7.209 14.491,5.579 14.852,3.764L14.978,3.14C15.262,1.718 16.646,0.794 18.068,1.079ZM2.679,9.779L6.179,9.779C7.147,9.779 7.929,10.561 7.929,11.529L7.929,23.779C7.929,24.747 7.147,25.529 6.179,25.529L2.679,25.529C1.711,25.529 0.929,24.747 0.929,23.779L0.929,11.529C0.929,10.561 1.711,9.779 2.679,9.779Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsUpSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumbs-up-selected.6e3bf710351a651a64e98b8334b50cca.svg";